export default __webpack_public_path__ + "static/media/fairweathers.c43d9398.jpg";